function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-star",
  "data-name": "Icon ionic-ios-star",
  d: "M17.035,8.315H11.989L10.455,3.739a.556.556,0,0,0-1.043,0L7.879,8.315H2.8a.55.55,0,0,0-.549.549.4.4,0,0,0,.01.093.527.527,0,0,0,.23.388l4.147,2.923L5.046,16.894a.55.55,0,0,0,.189.617.531.531,0,0,0,.309.134.672.672,0,0,0,.343-.123l4.048-2.885,4.048,2.885a.643.643,0,0,0,.343.123.493.493,0,0,0,.305-.134.544.544,0,0,0,.189-.617l-1.592-4.627,4.113-2.95.1-.086a.525.525,0,0,0-.4-.916Z",
  transform: "translate(-2.25 -3.375)",
  fill: "#01F2B4"
});

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.368,
    height: 14.27,
    viewBox: "0 0 15.368 14.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.82e2416be9bd9f3845795fed5ff7d75e.svg";
export { ForwardRef as ReactComponent };